<script>
import List from "@/resources/auction/List";

export default {
    extends: List
};
</script>
